import { useAtomValue } from 'jotai'
import { FC, useEffect } from 'react'

import { settingsState } from '../atoms/settingsState'
import { TopLinker } from '../components/TopLinker'

export const Home: FC = () => {
  const { title } = useAtomValue(settingsState)

  useEffect(() => {
    document.title = title
  }, [])

  return (
    <div className="container mx-auto px-1">
      <h1 className="text-xl font-semibold px-1 py-5">{title}</h1>
      <TopLinker />
    </div>
  )
}
